<script>
import PrimeButton from 'primevue/button';
import PrimeMenu from 'primevue/menu';
import BaseVolanInput from './BaseVolanInput';
export default {
  name: 'VolanOverlayMenu',
  components: {PrimeButton, PrimeMenu},
  extends: BaseVolanInput,
  inheritAttrs: true,
  props: {
    items: {
      type: Array,
      default: null
    },
  },
  data() {
    return {

    };
  },
  computed: {

  },
  methods: {
    toggle() {

    }
  }
};
</script>

<template>
  <div class="card flex justify-content-center">
    <slot name="activate"
          v-bind="{toggle, computedId}"
    >
      <PrimeButton type="button"
                   label="Toggle"
                   aria-haspopup="true"
                   :aria-controls="computedId"
                   @click="toggle"
      />
    </slot>
    <PrimeMenu :id="computedId"
               ref="menu"
               :model="items"
               :popup="true"
    >
      <template v-for="(_, name) in $scopedSlots"
                :slot="name"
                slot-scope="slotData"
      >
        <slot :name="name"
              v-bind="slotData"
        />
      </template>
      <slot v-for="(_, name) in $slots"
            :slot="name"
            :name="name"
      />
    </PrimeMenu>
  </div>
</template>